import React from 'react';

// important for SSR also on client to make 
// sure the styles are added to the manifest.json
import './App.css';
import './index.css';
import './custom.scss';

import Navigation from './components/Navigation'
import { ShopProvider } from './components/Shop/ShopContext'
import { BrowserRouter } from 'react-router-dom';

// keep the tree identical to AppServer, otherwise hydration fails
export default function App() 
{
  return (
    <BrowserRouter>
      <ShopProvider>
        <Navigation/>
      </ShopProvider>
    </BrowserRouter>
  );
}

